<main class="main-layout">
  <div class="bg-white">
    <nav
      app-navbar-horizontal
      class="navbar navbar-light navbar-horizontal navbar-expand-lg"
    ></nav>
    <app-breadcrumb></app-breadcrumb>
  </div>

  <div class="layout-body" [class.no-sidebar]="!showSidebar">
    @if(showSidebar) {
    <aside class="layout-sidebar">
      <app-navbar-vertical></app-navbar-vertical>
    </aside>
    }

    <section class="layout-content">
      <router-outlet></router-outlet>
    </section>
  </div>
</main>
